import React from 'react';

export interface DSIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

export type DSIconComponent = React.FC<DSIconProps>;

/**
 * Creates a React component from an SVG string
 * @param svgContent - The SVG content as a string
 * @param defaultSize - Default size for the icon (defaults to 24)
 * @returns A React functional component
 */
export const createIconComponent = (
  svgContent: string,
  defaultSize: number | string = 24
): DSIconComponent => {
  return ({ size = defaultSize, color, className, style, ...props }) => {
    // Parse the SVG to extract viewBox and other attributes
    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(svgContent, 'image/svg+xml');
    const svgElement = svgDoc.querySelector('svg');
    
    if (!svgElement) {
      console.error('Invalid SVG content provided');
      return null;
    }

    const viewBox = svgElement.getAttribute('viewBox') || '0 0 24 24';
    
    // Extract the inner content (everything except the svg wrapper)
    const innerHTML = svgElement.innerHTML;
    
    // Create the component with customizable props
    return React.createElement('svg', {
      width: size,
      height: size,
      viewBox,
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      className,
      style: {
        ...style,
        ...(color && { stroke: color, fill: color === 'currentColor' ? color : undefined })
      },
      ...props,
      dangerouslySetInnerHTML: { __html: innerHTML }
    });
  };
};
